//Core
import React from "react"

//Component
import Block from "./Block"

//style
import "./index.scss"
import Bounce from "react-reveal/Bounce"

const Box = ({ items, titleStyle, subtitle, size, title }) => {
  return (
    <section className="uahContainer">
      <div className={`uah_blocks ${size === "small" ? "small" : ""}`}>
        {title ? <div className="title">{title}</div> : null}
        <div className={`container`}>
          {items.map((item, index) => (
            <Bounce left={index === 0} right={index === 2}>
              <Block
                size={size}
                key={index}
                titleStyle={titleStyle}
                {...item}
              ></Block>
            </Bounce>
          ))}
        </div>
        {subtitle ? <div className="subtitle">{subtitle}</div> : null}
      </div>
    </section>
  )
}

export default Box
